import {openResourceModal} from '../../core/modalCommand';
import {
	NAT_CONFIG_CREATE_MODAL_EVENT,
	NAT_CONFIG_DELETE_MODAL_EVENT,
	NAT_CONFIG_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open the Add NAT form, with nothing filled in.
 *
 * This resource maps no fields: the agent opens the empty form and the
 * person completes it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openNatConfigCreateModal(command, envelope) {
	return openResourceModal(NAT_CONFIG_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit NAT profile for the resolved row.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openNatConfigEditModal(command, envelope) {
	return openResourceModal(NAT_CONFIG_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open the Delete NAT profile confirmation.
 *
 * The confirmation, not the deletion. Nothing is removed until the person
 * presses the button inside it, which is why this capability is declared
 * destructive rather than read: a read capability would be worked
 * automatically, and this one must not be.
 *
 * Canvas refuses some of these itself - a profile still attached to an
 * SSID or a Site cannot be deleted - and says so in its own words. That
 * refusal is left to Canvas rather than guessed at here.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openNatConfigDeleteModal(command, envelope) {
	return openResourceModal(NAT_CONFIG_DELETE_MODAL_EVENT, command, envelope);
}
